import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'disruption_compensation';
export const route = 'disruption_compensation/[bookingId]';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/DisruptionCompensationPage')));